<template>
  <div class="without" style="margin-top:0px">
    <div class="row">
      <figure class="text-center">
        <img src="img/logo-symbol1.png" alt width="210px" />
      </figure>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <h1>BIENVENIDO!</h1>
        <h4>
          Sistema para
          <br />las gestiones de cobros.
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "defaultdashboard",
  components: {},
  data: function() {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false
    };
  },
  created() {},
  methods: {
    getAllInfo() {
      showLoader();

      hideLoader();
    }
  }
};
</script>